import { AriaCheckboxProps, useCheckbox } from '@react-aria/checkbox';
import { useToggleState } from '@react-stately/toggle';
import { cx } from 'class-variance-authority';
import { useRef } from 'react';

export default function Checkbox(props: AriaCheckboxProps) {
    const { isIndeterminate, isSelected } = props;
    let state = useToggleState(props);
    let ref = useRef(null);
    let { inputProps } = useCheckbox(props, state, ref);

    return (
        <div className="group tw-grid tw-size-5 tw-grid-cols-1">
            <input
                type="checkbox"
                className="tw-col-start-1 tw-row-start-1 tw-appearance-none tw-rounded-md tw-border tw-border-solid tw-border-accents-2 tw-bg-white checked:tw-border-success checked:tw-bg-success indeterminate:tw-border-success indeterminate:tw-bg-success focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-success disabled:tw-border-accents-2 disabled:tw-bg-accents-2 disabled:checked:tw-bg-accents-5 forced-colors:tw-appearance-auto"
                ref={ref}
                {...inputProps}
            />
            <svg
                fill="none"
                viewBox="0 0 14 14"
                className="tw-pointer-events-none tw-col-start-1 tw-row-start-1 tw-size-3.5 tw-self-center tw-justify-self-center tw-stroke-white group-has-[:disabled]:tw-stroke-white/25"
            >
                <path
                    d="M3 8L6 11L11 3.5"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className={cx(!isIndeterminate && isSelected ? 'tw-opacity-100' : 'tw-opacity-0')}
                />
                <path
                    d="M3 7H11"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className={cx(isIndeterminate && !isSelected ? 'tw-opacity-100' : 'tw-opacity-0')}
                />
            </svg>
        </div>
    );
}
